import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { AssetClassEnum } from '@modules/positions-module/enums/asset-class.enum'
import { PositionSettingsInterface } from '@shared/components/trading/widgets/positions-widget/core/interfaces/position-settings.interface'
import { PositionsStocksComponent } from '@shared/components/trading/positions/stocks/positions-stocks.component'
import { PositionsOptionsComponent } from '@shared/components/trading/positions/options/positions-options.component'

@Component({
	selector: 'app-positions',
	templateUrl: './positions.component.html',
	styleUrl: './positions.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [PositionsStocksComponent, PositionsOptionsComponent],
})
export class PositionsComponent {
	protected readonly assetClassEnum: typeof AssetClassEnum = AssetClassEnum

	public widget: InputSignal<WidgetInterface<PositionSettingsInterface> | null> =
		input<WidgetInterface<PositionSettingsInterface> | null>(null)
}
